import { lazy } from 'react';
import _ from 'lodash';

const importComponents = (pageComponents, componentConfigs) => {
  const appData = [];
  for (const property of pageComponents) {
    const Component = lazy(() => {
      const moduleName = componentConfigs[property]?.module || property;
      // You're using _.forOwn to find a value in componentConfigs,
      // but this could be simplified with plain JavaScript,
      // such as componentConfigs[property]?.module.
      // Suggestion: Use direct property access for clarity and simplicity:

      // let moduleName = undefined;
      // _.forOwn(componentConfigs, function (value, key) {
      //   if (key === property) {
      //     moduleName = value?.module;
      //   }
      // });

      return import(
        `../modules/${moduleName || property}/${moduleName || property}`
      ).catch((err) => {
        console.error(`Failed to load component: ${property}`, err);
        return import('../modules/LazyImportFallback/LazyImportFallback');
      });
    });
    appData.push({ Component, ComponentName: property });
  }
  return appData;
};

export default importComponents;
